export { default } from './CloseCourse';
